import React, { useCallback, useEffect, useState } from 'react';
import { Typography, Segmented, Button, Space, message } from 'antd';
import { ReloadOutlined, ToolOutlined } from '@ant-design/icons';
import { usePermissions } from '../contexts/PermissionContext';
import { getCasos, CasoMejoraCU2 } from '../api/mejoraCU2Api';
import CasosTable from '../components/MejoraCU2/CasosTable';
import CasoDetailModal from '../components/MejoraCU2/CasoDetailModal';

const { Title } = Typography;

const FILTROS = [
  { label: 'Abiertos', value: 'ABIERTOS' },
  { label: 'Nuevos', value: 'NUEVO' },
  { label: 'En análisis', value: 'EN_ANALISIS' },
  { label: 'Resueltos', value: 'RESUELTO' },
  { label: 'Cerrados', value: 'CERRADO' },
  { label: 'Todos', value: 'TODOS' },
];

const MejoraCU2Page: React.FC = () => {
  const { hasPermission } = usePermissions();
  const capacidades = {
    tratar: hasPermission('GCvsc.MejoraCU2.Tratar'),
    gestionar: hasPermission('GCvsc.MejoraCU2.Gestionar'),
  };
  const [casos, setCasos] = useState<CasoMejoraCU2[]>([]);
  const [loading, setLoading] = useState(false);
  const [filtro, setFiltro] = useState<string>('ABIERTOS');
  const [casoId, setCasoId] = useState<number | null>(null);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const estado = filtro === 'TODOS' || filtro === 'ABIERTOS' ? undefined : filtro;
      let data = await getCasos(estado);
      if (filtro === 'ABIERTOS') data = data.filter(c => c.estado !== 'CERRADO');
      setCasos(data);
    } catch {
      message.error('No se pudieron cargar los casos');
    } finally { setLoading(false); }
  }, [filtro]);

  useEffect(() => { cargar(); }, [cargar]);

  return (
    <div style={{ padding: '0 8px' }}>
      <div style={{ background: '#fff', padding: '16px 24px', borderRadius: 8 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, paddingBottom: 12, borderBottom: '1px solid #f0f0f0' }}>
          <Space><ToolOutlined /><Title level={4} style={{ margin: 0 }}>Mejora CU2 — Casos GDO</Title></Space>
          <Button icon={<ReloadOutlined />} onClick={cargar} loading={loading}>Actualizar</Button>
        </div>
        <div style={{ marginBottom: 16 }}>
          <Segmented options={FILTROS} value={filtro} onChange={(v) => setFiltro(v as string)} />
        </div>
        <CasosTable casos={casos} loading={loading} onRowClick={(c) => setCasoId(c.id)} />
      </div>
      <CasoDetailModal casoId={casoId} capacidades={capacidades} onClose={() => setCasoId(null)} onChanged={cargar} />
    </div>
  );
};

export default MejoraCU2Page;
